import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty, isNil, pathOr } from "ramda";
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { useSelector } from "react-redux";
import useStyles, { getMuiTheme } from "./styles";
import { useTheme } from '@material-ui/core/';
import { MuiThemeProvider } from "@material-ui/core/styles";
import PreviewCustomReports from './previewCustomReports';
import { getCustomReport } from "../../../../../../store/actions/dashboard.actions";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import GetAppIcon from '@material-ui/icons/GetApp';

function CustomReports({ data , allTabFilter }) {
  // console.log(";;;;;;;;",data)
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const [reports, setReports] = useState(pathOr([], ['data'], data));
  const [preview, setPreview] = useState(false);
  const [previewId, setPreviewId] = useState(null);
  const [reportData, setReportData] = useState({});
  const [requestData, setRequestData] = useState({});
  
  const [loading, setLoading] = useState(false);
  const { dashboardData} = useSelector((state) => state.dashboard);

  // const [allTabFilter,setAllTabFilter] = useState(pathOr([], [0, "allTabFilter"], dashboardData));

  const {currentUserData} = useSelector((state) => state.config);
  const currentUser = pathOr([], ["data", "attributes"], currentUserData);
  const currentUserType = currentUser["type_c"];

  const reportToPreview = (row) => {
    setLoading(true);
    setPreviewId(row);
    toast("We are preparing your report for download...");
    try {
      dispatch(getCustomReport(pathOr([], [row], reports),allTabFilter)).then(function (res) {
        let instanceURL = process.env.REACT_APP_BASE_URL.replace("Api", "");
        // console.log("customReports", res.data)

        if (pathOr(false, ['ok'], res)) {
        // console.log("customReports 2", res.data)
          
          setPreview(true);
          setReportData(pathOr({}, ["data"], res));
          setRequestData(pathOr({}, [row], reports));
          toast("Now report is ready for download.");
          setLoading(false);
          setPreviewId(null);
        } else {
          toast('Something went wrong!');
          setLoading(false);
          setPreviewId(null);
          setRequestData([]);

        }
      });
    } catch (e) {
      toast("Something went wrong!");
    }
  }

  // }
  const makeid = (length = 5) => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
  };
  
  return (
    <MuiThemeProvider theme={getMuiTheme(theme)}>

      <div key={makeid()}>

        <TableContainer component={Paper} key={makeid()}>
          <Table size="small" aria-label="a dense table" key={makeid()}>
            <TableHead key={makeid()}>
              <TableRow className={classes.tableHeading} key={makeid()}>
                {/* <TableCell align="left" className={classes.tableCellHead}>Sr. No.</TableCell> */}
                <TableCell key={makeid()} align="left" className={classes.tableCellHead}>Name</TableCell>
                <TableCell key={makeid()} align="center" className={classes.tableCellHead}>Download</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.values(reports).map((item, row) => pathOr(false, [row,'isDownload'], reports) 
              ?
                <TableRow
                  key={makeid()}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  {/* <TableCell align="left" className={classes.tableCellBody}>{row+1} </TableCell> */}
                  <TableCell key={makeid()} align="left" className={classes.tableCellBody}> {item.label} </TableCell>
                  <TableCell key={makeid()} align="center" >
                    {previewId === row ? <CircularProgress size={30} /> 
                    : <IconButton 
                        key={makeid()} aria-label="Preview" 
                        className={classes.link}
                        onClick={() => reportToPreview(row)} 
                        size="small" 
                      >
                      {/* <VisibilityIcon key={makeid()} fontSize="inherit" color="primary" /> */}
                      <GetAppIcon key={makeid()} fontSize="inherit" color="primary" />
                    </IconButton>}
                  </TableCell>
                </TableRow>
              :null

              )}

            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ color: 'error.main', pt:1,fontSize: '15px' }}>Note: Report is password protected, To open it please use {currentUserType === 'Agent'? 'agent code':'date of birth in (YYYYMMDD format)'}.</Box>
        {preview ? (
          !isEmpty(requestData) && !isNil(requestData) && !isNil(reportData) && !isEmpty(reportData) 
          ?
            <PreviewCustomReports
              key={makeid()} 
              open={preview} 
              setOpen={setPreview} 
              requestData={requestData} 
              reportData={reportData} 
            /> : <></>
          ): (<></>)
        }
      </div>
    </MuiThemeProvider>
  );
}

export default React.memo(CustomReports)